export interface IFinanceReports {
  id: number;
  code: string;
  name: string;
}
